import { IsNumber, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { MachineRangeDto } from 'src/app/shared/dtos/machine.dto';

export class ContentListResponseDto {
  @IsString()
  region: string;

  @IsString()
  region_name: string;

  @ValidateNested({ each: true })
  @Type(() => MachineRangeDto)
  content: MachineRangeDto[];

  @IsNumber()
  timestamp: number;
}
